import React, { useEffect, useState } from 'react';
import { Actions } from '../../../client/Actions';

const SecureIframe = ({ fileName, filePath }) => {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (filePath) {
      Actions.getBlob(`/file/private/${filePath.split('/').pop()}`, (blob) => {
        const url = URL.createObjectURL(blob);
        setBlobUrl(url);
      });
    }
  }, [filePath]);

  if (!blobUrl) return <div>Ładowanie pliku...</div>;

  return (
    <iframe
      title={fileName}
      src={blobUrl}
      style={{ width: '100%', height: '80vh', border: 'none' }}
    />
  );
};

export default SecureIframe;
